import get from "lodash/get";
import { selectAppConfig } from "./selectAppConfig";

export const selectPredefinedCustomerData = (state) =>
  get(selectAppConfig(state), "application_info.fields.customer");
